import styled from 'styled-components';

export const ItemRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ItemInput = styled.input`
  width: ${({ width }) => width || '100%'};
  margin-bottom: 0;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const SelectWrapper = styled.div`
  min-width: 300px;

  @media (max-width: 600px) {
    min-width: 100%;
  }
`;

export const RemoveIcon = styled.div`
  cursor: pointer;
  margin-left: 10px;
  font-size: 1.5rem;

  @media (max-width: 600px) {
    margin-left: 0;
    margin-top: 10px;
  }
`;